import React, { useState } from 'react';
import { Droplet, Fan, Info, ChartLine, Snowflake } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Mode } from '@/types';
import { modeConfig } from '../ahu/mode-badge';

interface ModeCardProps {
  type: Mode;
  count: number;
}
export function ModeCard({ type, count }: ModeCardProps) {
  const config = modeConfig[type];
  return (
    <div className="flex-1 pt-1 pb-1 pl-2 pr-2 bg-bg border border-light-grey rounded-[6px] flex flex-col justify-between">
    <div className="flex items-center gap-[4px]">
        <config.icon className="w-[12px] h-[12px] text-primary" />
      <span className="paragraph-11 text-black capitalize">{type}</span>
    </div>
      <span className="heading-7 font-semibold tracking-[0.01em] text-dark-blue">
        {count} unit{count > 1 ? 's' : ''}
      </span>
    </div>
  );
}